import { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { initLogRocket } from './analytics/logrocket';
import Login from './components/auth/login';
import RequireAuth from './components/auth/RequireAuth';
import MainLayout from './components/main_layout';
import History from './components/pages/History';
import PortalLayout from './components/portal/PortalLayout';
import AuthProvider from './context/AuthProvider';
import { NoteProvider } from './context/NoteProvider';
import { SimpleAudioProvider } from './context/SimpleAudioProvider';
import { cleanupViewportHeight, initViewportHeight } from './utils/viewport';

export default function App() {
  // Initialize viewport height handling for iOS mobile devices
  useEffect(() => {
    initViewportHeight();
    initLogRocket();

    return () => {
      cleanupViewportHeight();
    };
  }, []);
  return (
    <AuthProvider>
      <NoteProvider>
        <SimpleAudioProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/portal"
                element={
                  <RequireAuth>
                    <MainLayout>
                      <PortalLayout />
                    </MainLayout>
                  </RequireAuth>
                }
              />
              <Route
                path="/history"
                element={
                  <RequireAuth>
                    <MainLayout>
                      <History />
                    </MainLayout>
                  </RequireAuth>
                }
              />
            </Routes>
          </Router>
        </SimpleAudioProvider>
      </NoteProvider>
    </AuthProvider>
  );
}

